






















































































import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from "@/config/handleErrors";
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {fetchMID} from "@/pantallas/MID/fetchMID";

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import IntegrationLists from "@/pantallas/MID/bloqueoServicio/IntegrationLists.vue";
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    IntegrationLists,
    'app-confirmacion': Confirmation,
  },
})
export default class AsignacionvehiculosWS extends ComponenteBase {
  [x: string]: any;
  dialogConfirmacion: boolean = false;
  filtro: any = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades = Funcionalidades.MIDAsignacionEsquemas;
  clienteId: number = config.getClienteSesion();
  selectedItem: any;
  endPoints: any = [];
  dataTotal: any = [];
  sinEsquema: any = [];
  asignarEsquema: any = [];
  clientes: any[] = [];
  clientesAll: any = [];
  showTables = false;
  headers: any[] = [
    { text: 'Nombre Endpoint', value: 'nombre_ws' },
    { text: 'Integrador', value: 'integrador' },
  ];
  tablaDatos: any = [];
  pagination: any = {
    rowsPerPage: 5,
  };
  rowsPerPage: any = [5, 10, 25, { text: 'Todos', value: -1 }];

  formFields: {
    clientes: any;
  } = {
    clientes: {
      label: 'Clientes',
      value: '',
      items: this.clientesall,
      formatItem: (item: { nombre: any; rut: any }) =>
          `${item.nombre} [${item.rut}]`,
    },
  };
  action: string = 'Cortar';
  clientActive: boolean;
  itemsVehiculosAsignados: any = [];
  async clearFilters() {
    this.formFields.clientes.value = undefined;
    this.showTables = false;
    this.orderList = [];
    this.sinEsquema = [];
    this.asignarEsquema = [];
  }
  async getIntegracionesCliente() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
        { clienteid: this.formFields.clientes.value.toString() },
        'mid_cliente/Getintegracionescliente '
    )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            return data.data.data;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
  }

  async getIntegracionesFaltantes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
        { clienteid: this.formFields.clientes.value.toString() },
        'mid_cliente/GetintegracionesFaltantes '
    )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            return data.data.data;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
  }
  delete: any;
  usuarioActivo: any = {};
  idsIntegraciones: any = [];

  async datoNuevo(dato: any) {
    if (dato) {
      this.showTables = false;
      await this.showTable();
    }
  }

  async handleGridReady(event: GridReadyEvent) {}

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  async showTable() {
    if (
        this.formFields.clientes.value == '' ||
        this.formFields.clientes.value === null ||
        this.formFields.clientes.value === undefined
    ) {
      this.showTables = false;
      this.orderList = [];
      this.sinEsquema = [];
      this.asignarEsquema = [];
      this.$snotify.error('Selecione un cliente', { timeout: 3000 });
    } else {
      this.showTables = true;
      this.tablaDatos = [];
      sessionStorage.setItem('clienteMid', this.formFields.clientes.value);
      this.ordesList = (await this.getIntegracionesCliente()) || [];
      const transformedData = this.ordesList
          .map(item => ({
            nombre_ws: item.nombrewebservice,
            integrador: item.integrador,
            id: item.id,
          }))
          .sort((a: any, b: any) => {
            if (a.nombre_ws > b.nombre_ws) {
              return 1;
            } else if (a.nombre_ws < b.nombre_ws) {
              return -1;
            } else {
              return 0;
            }
          });
      this.tablaDatos = transformedData;
      this.idsIntegraciones = this.tablaDatos.map((item: any) => item.id);
      await this.getEstadoGeneral();
    }
  }

  async getEstadoGeneral() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
        { clienteid: this.formFields.clientes.value.toString(), ids: this.idsIntegraciones },
        'mid_cliente/GetEstadoGeneral'
    )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == 1 && data.data.MENSAJE_RESPUESTA == 'OK'){
            self.clientActive = data.data.result;
            self.action = self.clientActive ? 'Cortar' : 'Activar';
          }else{
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionCrear];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  showModalAsignar: boolean = false;

  async getAllCliente() {
    let self = this;
    self.loadingService.showLoading();
    return fetchMID({ canal: 'gpschile' }, 'marcaBlanca/getClient')
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.cliente = data.data.data || [];
            const filteredDatas = this.cliente
                .map((item: { nombre: any; rut: any; id: any }) => ({
                  nombre: item.nombre,
                  rut: item.rut,
                  id: item.id,
                }))
                .sort((a: any, b: any) => {
                  if (a.nombre > b.nombre) {
                    return 1;
                  } else if (a.nombre < b.nombre) {
                    return -1;
                  } else {
                    return 0;
                  }
                });

            if (filteredDatas.length > 0) {
              this.clientesAll = filteredDatas;
            }
            const clienteMid = sessionStorage.getItem('clienteMid');

            // Si hay un valor, busque el ID correspondiente en la lista de clientes
            if (clienteMid) {
              const clienteId = parseInt(clienteMid, 10);
              const clienteEncontrado = this.clientesAll.find(
                  (cliente: { id: number }) => cliente.id === clienteId
              );

              if (clienteEncontrado) {
                // Seleccione el cliente encontrado
                this.formFields.clientes.value = clienteEncontrado.id;
              }
            }
            return data.data.data;
          } else {
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          }
        })
        .catch((error: any) => {
          self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        })
        .finally(() => {
          this.loadingService.hideLoading();
          return null;
        });
  }
  mounted() {
    eventBus.changeTitlePage('Módulos');
    this.getAllCliente();
  }

  created() {
    this.initialize();
  }

  onFilterTextBoxChanged() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.search.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.search.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.intervalo);
    }, 500);
  }
  rutSelected: string = '';
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.AsignacionEsquemas) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.proveedorrut;
          }
        }
      }
    });
  }

  beforeDestroy() {}

  async confirmCallback(val: boolean) {
    if (val){
      let self = this;
      this.loadingService.showLoading();
      return fetchMID(
          { clienteid: this.formFields.clientes.value.toString(), ids: this.idsIntegraciones, action: this.action },
          'mid_cliente/PostVerificaCorte'
      )
          .then((data: any) => {
            if (data.data.CODIGO_RESPUESTA == 1 && data.data.MENSAJE_RESPUESTA == 'OK'){
              self.showTable();
              self.$snotify.success('Corte realizado exitosamente', { timeout: 2000 });
            }else{
              self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
            }
          })
          .catch((error: any) => {
            self.$snotify.error('Ocurrió un error', { timeout: 3000 });
          })
          .finally(() => {
            this.loadingService.hideLoading();
            self.dialogConfirmacion = false;
            return null;
          });
    }else {
      this.dialogConfirmacion = false;
    }
  }
}
